import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-neutral-900 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col items-center space-y-8">
          {/* Logo */}
          <img
            src="https://customer-assets.emergentagent.com/job_28b33ae7-3c8b-44fa-9343-f9f615e11717/artifacts/p03aed6e_Wordmark.png"
            alt="Centurio Prime Wordmark"
            className="h-16 object-contain"
            data-testid="footer-logo"
          />

          {/* Divider */}
          <div className="w-full max-w-md h-px bg-gold/30"></div>

          {/* Contact Icons */}
          <div className="flex items-center gap-6" data-testid="footer-contact-icons">
            <a
              href="tel:+923016697234"
              className="w-12 h-12 rounded-full border border-gold flex items-center justify-center text-gold hover:bg-gold hover:text-black transition-all duration-300"
              aria-label="Call us"
              data-testid="footer-phone-link"
            >
              <Phone className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/923016697234"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full border border-gold flex items-center justify-center text-gold hover:bg-gold hover:text-black transition-all duration-300"
              aria-label="WhatsApp us"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
          </div>

          {/* Copyright */}
          <p className="font-montserrat text-sm text-neutral-400 text-center" data-testid="footer-copyright">
            © 2026 Centurio Prime – Snooker & Cue Lounge. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
